const parseDndData = (response) => {
  const { data } = response;
  let allIds = [];
  let byId = {};

  data.forEach((dndRecord) => {
    allIds.push(dndRecord.mobileNumber);
    byId[dndRecord.mobileNumber] = dndRecord;
  });

  return { allIds, byId };
};

export default parseDndData;
